import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/PieceRamaceDesktop.css";

/* ===============================
   Mutations GraphQL
   ============================== */

const INSERT_CARTE_IDENTITE_RAMASSEE = gql`
  mutation InsertCarteIdentiteRamassee(
    $lieu_vote: String!,
    $adresse: String!,
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $telephone: String!
  ) {
    insert_carteidentiteramassee_one(object: {
      lieu_vote: $lieu_vote,
      adresse: $adresse,
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_CARTE_ETUDIANT_RAMASSEE = gql`
  mutation InsertCarteEtudiantRamassee(
    $ine: String!,
    $ecole_rattachement: String!,
    $nom: String!,
    $prenom: String!,
    $filiere: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $telephone: String!
  ) {
    insert_carteetudiantramassee_one(object: {
      ine: $ine,
      ecole_rattachement: $ecole_rattachement,
      nom: $nom,
      prenom: $prenom,
      filiere: $filiere,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_PASSEPORT_RAMASSE = gql`
  mutation InsertPasseportRamasse(
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $nationalite: String!,
    $telephone: String!
  ) {
    insert_passeportramasse_one(object: {
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      nationalite: $nationalite,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_PERMIS_RAMASSE = gql`
  mutation InsertPermisRamasse(
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $categories: String!,
    $adresse: String!,
    $telephone: String!
  ) {
    insert_permisramasse_one(object: {
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      categories: $categories,
      adresse: $adresse,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_CARTE_COMMERCE_RAMASSEE = gql`
  mutation InsertCarteCommerceRamassee(
    $nom: String!,
    $prenom: String!,
    $profession: String!,
    $numero_agrement: String!,
    $telephone: String!
  ) {
    insert_cartecommerceramassee_one(object: {
      nom: $nom,
      prenom: $prenom,
      profession: $profession,
      numero_agrement: $numero_agrement,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_CARTE_PROFESSIONNELLE_RAMASSEE = gql`
  mutation InsertCarteProfessionnelleRamassee(
    $nom: String!,
    $prenom: String!,
    $matricule: String!,
    $telephone: String!
  ) {
    insert_carteprofessionnelleramassee_one(object: {
      nom: $nom,
      prenom: $prenom,
      matricule: $matricule,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// ✅ CORRIGÉ : Nom de la mutation correcte + suppression du champ etat
const INSERT_CARTE_GRISE_RAMASSEE = gql`
  mutation InsertCarteGriseRamassee(
    $nom: String!,
    $prenom: String!,
    $numero_plaque: String!,
    $marque_modele: String!,
    $telephone: String!
  ) {
    insert_cartegriseramassee_one(object: {
      nom: $nom,
      prenom: $prenom,
      numero_plaque: $numero_plaque,
      marque_modele: $marque_modele,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

const INSERT_AUTRE_DOCUMENT_RAMASSE = gql`
  mutation InsertAutreDocumentRamasse(
    $nom: String!,
    $prenom: String!,
    $type_document: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $description: String,
    $telephone: String!
  ) {
    insert_autredocumentramasse_one(object: {
      nom: $nom,
      prenom: $prenom,
      type_document: $type_document,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      description: $description,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

/* ===============================
   Composant principal
   ============================== */

const PieceRamaceDesktop = () => {
  const [selectedType, setSelectedType] = useState("");
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    type_document: "",
    date_naissance: "",
    lieu_naissance: "",
    description: "",
    lieu_vote: "",
    adresse: "",
    ine: "",
    ecole_rattachement: "",
    filiere: "",
    nationalite: "",
    categories: "",
    profession: "",
    numero_agrement: "",
    matricule: "",
    numero_plaque: "",
    marque_modele: "",
    telephone: "", // ✅ etat supprimé du state
  });

  const [insertCarteIdentite] = useMutation(INSERT_CARTE_IDENTITE_RAMASSEE);
  const [insertCarteEtudiant] = useMutation(INSERT_CARTE_ETUDIANT_RAMASSEE);
  const [insertPasseport] = useMutation(INSERT_PASSEPORT_RAMASSE);
  const [insertPermis] = useMutation(INSERT_PERMIS_RAMASSE);
  const [insertCarteCommerce] = useMutation(INSERT_CARTE_COMMERCE_RAMASSEE);
  const [insertCarteProfessionnelle] = useMutation(INSERT_CARTE_PROFESSIONNELLE_RAMASSEE);
  const [insertCarteGrise] = useMutation(INSERT_CARTE_GRISE_RAMASSEE);
  const [insertAutreDocumentRamasse] = useMutation(INSERT_AUTRE_DOCUMENT_RAMASSE);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData({
      nom: "",
      prenom: "",
      type_document: "",
      date_naissance: "",
      lieu_naissance: "",
      description: "",
      lieu_vote: "",
      adresse: "",
      ine: "",
      ecole_rattachement: "",
      filiere: "",
      nationalite: "",
      categories: "",
      profession: "",
      numero_agrement: "",
      matricule: "",
      numero_plaque: "",
      marque_modele: "",
      telephone: "",
    });
    setSelectedType("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedDate = formData.date_naissance
      ? new Date(formData.date_naissance).toISOString().split("T")[0]
      : "";

    try {
      switch (selectedType) {
        case "carte_identite":
          await insertCarteIdentite({
            variables: { ...formData, date_naissance: formattedDate },
          });
          break;
        case "carte_etudiant":
          await insertCarteEtudiant({
            variables: { ...formData, date_naissance: formattedDate },
          });
          break;
        case "passeport":
          await insertPasseport({
            variables: { ...formData, date_naissance: formattedDate },
          });
          break;
        case "permis":
          await insertPermis({
            variables: { ...formData, date_naissance: formattedDate },
          });
          break;
        case "carte_commerce":
          await insertCarteCommerce({
            variables: {
              nom: formData.nom,
              prenom: formData.prenom,
              profession: formData.profession,
              numero_agrement: formData.numero_agrement,
              telephone: formData.telephone,
            },
          });
          break;
        case "carte_professionnelle":
          await insertCarteProfessionnelle({
            variables: {
              nom: formData.nom,
              prenom: formData.prenom,
              matricule: formData.matricule,
              telephone: formData.telephone,
            },
          });
          break;
        // ✅ CORRIGÉ : Variables sans etat pour carte grise
        case "carte_grise":
          await insertCarteGrise({
            variables: {
              nom: formData.nom,
              prenom: formData.prenom,
              numero_plaque: formData.numero_plaque,
              marque_modele: formData.marque_modele,
              telephone: formData.telephone,
            },
          });
          break;
        case "autre_document_ramasse":
          await insertAutreDocumentRamasse({
            variables: { ...formData, date_naissance: formattedDate },
          });
          break;
        default:
          toast.error("⚠️ Veuillez sélectionner un type de document !");
          return;
      }

      toast.success("✅ Déclaration enregistrée avec succès !");
      resetForm();
    } catch (err) {
      console.error("Erreur lors de l'insertion :", err);
      toast.error("❌ Une erreur est survenue lors de la déclaration !");
    }
  };

  return (
    <div className="page-shell found-page">
      <Header />

      <main className="piece-wrapper">
        {/* HERO */}
        <section className="page-hero">
          <div>
            <p className="eyebrow">_________________</p>
            <h2 className="title">Déclarer une carte ou pièce ramassée</h2>
            <p className="intro-text">
              Signalez rapidement une pièce retrouvée pour que son propriétaire
              puisse être contacté.
            </p>
          </div>
          <a
            href="https://wa.me/221777600767"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-badge"
            style={{ color: "#ffffff", textDecoration: "none" }}
          >
            Assistance 7j/7
          </a>
        </section>

        {/* ÉTAPE 1 : TYPE DE DOCUMENT */}
        <section className="card">
          <div className="section-header">
            <div>
              <p className="eyebrow">Type de document</p>
              <h3 className="section-title">Sélectionnez la pièce ramassée</h3>
            </div>
            <div className="pill">Étape 1/2</div>
          </div>

          <div className="field compact-field">
            <label>Type de carte</label>
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              required
            >
              <option value="">-- Sélectionner --</option>
              <option value="carte_identite">Carte d'Identité</option>
              <option value="carte_etudiant">Carte Étudiant</option>
              <option value="passeport">Passeport</option>
              <option value="permis">Permis</option>
              <option value="carte_commerce">Carte de Commerce</option>
              <option value="carte_professionnelle">Carte Professionnelle</option>
              <option value="carte_grise">Carte Grise</option>
              <option value="autre_document_ramasse">Autre Document Ramassé</option>
            </select>
          </div>
        </section>

        {/* ÉTAPE 2 : FORMULAIRE */}
        {selectedType && (
          <section className="card">
            <div className="section-header">
              <div>
                <p className="eyebrow">Informations</p>
               <center> <h3 className="section-title">Détails de la pièce retrouvée</h3></center>
                <p className="section-description">
                  Merci de remplir les informations ci-dessous pour faciliter la
                  vérification et la prise de contact.
                </p>
              </div>
              <div className="pill">Étape 2/2</div>
            </div>

            <form className="form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="field">
                  <label>Nom *</label>
                  <input
                    type="text"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label>Prénom *</label>
                  <input
                    type="text"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label>Téléphone *</label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    required
                    pattern="[0-9]{9,}"
                    placeholder="Ex: 771234567"
                  />
                </div>

                {(selectedType === "carte_identite" ||
                  selectedType === "carte_etudiant" ||
                  selectedType === "passeport" ||
                  selectedType === "permis" ||
                  selectedType === "autre_document_ramasse") && (
                  <>
                    <div className="field">
                      <label>Date de naissance *</label>
                      <input
                        type="date"
                        name="date_naissance"
                        value={formData.date_naissance}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="field">
                      <label>Lieu de naissance *</label>
                      <input
                        type="text"
                        name="lieu_naissance"
                        value={formData.lieu_naissance}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_identite" && (
                  <>
                    <div className="field">
                      <label>Lieu de vote</label>
                      <input
                        type="text"
                        name="lieu_vote"
                        value={formData.lieu_vote}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field">
                      <label>Adresse</label>
                      <input
                        type="text"
                        name="adresse"
                        value={formData.adresse}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_etudiant" && (
                  <>
                    <div className="field">
                      <label>INE *</label>
                      <input
                        type="text"
                        name="ine"
                        value={formData.ine}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>École de rattachement *</label>
                      <input
                        type="text"
                        name="ecole_rattachement"
                        value={formData.ecole_rattachement}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Filière *</label>
                      <input
                        type="text"
                        name="filiere"
                        value={formData.filiere}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </>
                )}

                {selectedType === "passeport" && (
                  <div className="field">
                    <label>Nationalité *</label>
                    <input
                      type="text"
                      name="nationalite"
                      value={formData.nationalite}
                      onChange={handleChange}
                      required
                    />
                  </div>
                )}

                {selectedType === "permis" && (
                  <>
                    <div className="field">
                      <label>Catégories *</label>
                      <input
                        type="text"
                        name="categories"
                        value={formData.categories}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Adresse</label>
                      <input
                        type="text"
                        name="adresse"
                        value={formData.adresse}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_commerce" && (
                  <>
                    <div className="field">
                      <label>Profession *</label>
                      <input
                        type="text"
                        name="profession"
                        value={formData.profession}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Numéro d'agrément</label>
                      <input
                        type="text"
                        name="numero_agrement"
                        value={formData.numero_agrement}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_professionnelle" && (
                  <div className="field">
                    <label>Matricule</label>
                    <input
                      type="text"
                      name="matricule"
                      value={formData.matricule}
                      onChange={handleChange}
                    />
                  </div>
                )}

                {/* ✅ CORRIGÉ : Champ etat supprimé pour carte grise */}
                {selectedType === "carte_grise" && (
                  <>
                    <div className="field">
                      <label>Numéro de plaque</label>
                      <input
                        type="text"
                        name="numero_plaque"
                        value={formData.numero_plaque}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field">
                      <label>Marque et modèle</label>
                      <input
                        type="text"
                        name="marque_modele"
                        value={formData.marque_modele}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "autre_document_ramasse" && (
                  <>
                    <div className="field">
                      <label>Type de document</label>
                      <input
                        type="text"
                        name="type_document"
                        value={formData.type_document}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field full-row">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="button-row">
                <button type="submit">Soumettre la déclaration</button>
              </div>
            </form>
          </section>
        )}
      </main>

      <Footer />

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default PieceRamaceDesktop;